import React from 'react'
import { Alert, AlertTitle } from '@mui/material'

const PersonaliseAlert = () => (
  <Alert severity='success' data-test='personalise-alert' role='alert' aria-live='polite'>
    <AlertTitle data-test='personalise-alert-title'>Profile Updated</AlertTitle>
    <span data-test='personalise-alert-message'>
      Your learning preferences have been saved and will help us personalize your experience.
    </span>
  </Alert>
)

export default PersonaliseAlert
